import Button from "components/Button";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IImportCompleted {
  handleStartProcessOver: () => void;
}
const ImportCompleted = ({ handleStartProcessOver }: IImportCompleted) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    spacing={6}
    padding={8}
    flexGrow={1}
  >
    <Text variant="h2" textAlign="center">
      The Checklist file import has been successfully completed!
    </Text>
    <Button onClick={handleStartProcessOver}>Start over</Button>
  </Stack>
);

export default ImportCompleted;
